export default "__VITE_ASSET__ac534341__"